import axios from 'axios';
import { API_BASE_URL } from './config';
import authHeader from './authHeader';

// Service for managing service offerings
const serviceManagementService = {
  // Services CRUD operations
  getAllServices: async (params = {}) => {
    const response = await axios.get(`${API_BASE_URL}services/`, {
      headers: authHeader(),
      params
    });
    return response.data;
  },

  getServiceById: async (id) => {
    const response = await axios.get(`${API_BASE_URL}services/${id}/`, {
      headers: authHeader()
    });
    return response.data;
  },

  createService: async (serviceData) => {
    const response = await axios.post(`${API_BASE_URL}services/`, serviceData, {
      headers: authHeader()
    });
    return response.data;
  },

  updateService: async (id, serviceData) => {
    const response = await axios.put(`${API_BASE_URL}services/${id}/`, serviceData, {
      headers: authHeader()
    });
    return response.data;
  },

  // Multipart variants — used when a service image file is uploaded.
  createServiceForm: async (formData) => {
    const response = await axios.post(`${API_BASE_URL}services/`, formData, {
      headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  updateServiceForm: async (id, formData) => {
    const response = await axios.put(`${API_BASE_URL}services/${id}/`, formData, {
      headers: { ...authHeader(), 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  deleteService: async (id) => {
    const response = await axios.delete(`${API_BASE_URL}services/${id}/`, {
      headers: authHeader()
    });
    return response.data;
  },

  // Sessions CRUD operations
  getAllSessions: async (params = {}) => {
    const response = await axios.get(`${API_BASE_URL}sessions/`, {
      headers: authHeader(),
      // Load the full set by default (server default is only 50 rows) so the
      // history totals / « Chiffre d'affaires » aren't truncated. Callers can
      // still override page_size.
      params: { page_size: 5000, ...params }
    });
    return response.data;
  },

  getSellerSessions: async (params = {}) => {
    const response = await axios.get(`${API_BASE_URL}seller-sessions/`, {
      headers: authHeader(),
      params
    });
    return response.data;
  },

  getSessionById: async (id) => {
    const response = await axios.get(`${API_BASE_URL}sessions/${id}/`, {
      headers: authHeader()
    });
    return response.data;
  },

  createSession: async (sessionData) => {
    const response = await axios.post(`${API_BASE_URL}sessions/`, sessionData, {
      headers: authHeader()
    });
    return response.data;
  },

  updateSession: async (id, sessionData) => {
    const response = await axios.put(`${API_BASE_URL}sessions/${id}/`, sessionData, {
      headers: authHeader()
    });
    return response.data;
  },

  updateSessionStatus: async (id, status) => {
    const response = await axios.post(`${API_BASE_URL}update-session-status/${id}/`, { status }, {
      headers: authHeader()
    });
    return response.data;
  },

  deleteSession: async (id) => {
    const response = await axios.delete(`${API_BASE_URL}sessions/${id}/`, {
      headers: authHeader()
    });
    return response.data;
  }
};

export default serviceManagementService;
